// @vendors
import React, { useMemo } from 'react'

// @components
import {
    Box,
    Card,
    Typography,
  } from '../shared/MaterialUI';
import { EmployeeDetailStyles } from '../../assets/css/employeeTable-style';
import { theme } from '../../assets/theme';

const DetailCardEmployee = ({title, value, color}) => {
    const styles = useMemo(() => EmployeeDetailStyles(), []);

  return (
    <Card elevation={0} sx={styles.box}>
      <Box sx={styles.boxContainer} >
        <Typography
          variant="body1" 
          sx={{
            ...styles.employeeDetailTypographicBox,
            fontWeight: 'bold',
          }}
        >
          {title} 
        </Typography>
        <Typography
          variant="body1"
          sx={{
            ...styles.employeeDetailTypographicBox,
            fontSize: '13px',
            color: color ?? theme.palette.secondary.black,
          }}
        >
            {value}
        </Typography>
      </Box>
    </Card>
  )
}

export default DetailCardEmployee